import React from 'react';
import { FormattedMessage } from 'react-intl';

import type { GroupedMediaListProps } from '../../types';
import { GroupedList, StyledTitle } from '../UI';
import { sortMediasAndDocuments } from '../utils';

import MediaList from './MediaList';

const GroupedMediaList: React.FC<GroupedMediaListProps> = ({ mediaList, groupBy = sortMediasAndDocuments, hideTitle, ...rest }) => {
  const sortedMedias = groupBy(mediaList);
  const entries = Object.entries(sortedMedias).filter(([, medias]) => medias.length > 0);

  return (
    <GroupedList className="media-grouped-list">
      {entries.map(([mediaType, medias]) => (
        <React.Fragment key={mediaType}>
          {!hideTitle && (
            <StyledTitle level={4}>
              <FormattedMessage id={`page.fiche.medias.titles.${mediaType}`} defaultMessage={mediaType.toLowerCase()} />
            </StyledTitle>
          )}
          <MediaList mediaList={medias} {...rest} />
        </React.Fragment>
      ))}
    </GroupedList>
  );
};

export default GroupedMediaList;
